import React from 'react';
import PropTypes from 'prop-types';
import FsLightbox from 'fslightbox-react';

import CommonPropTypes from 'utils/propTypes/common';

import Image from './components/Image';

import styles from './styles.module.scss';

const Lightbox = ({ materials, toggler, onClose, slide }) => {
	const sources = materials.map((file) => (
		<div>
			<Image file={file} alone={materials.length === 1} />
		</div>
	));

	return (
		<div className={styles.lightbox}>
			<FsLightbox
				onClose={onClose}
				toggler={toggler}
				type="image"
				slide={slide || 1}
				sources={sources}
			/>
		</div>
	);
};

Lightbox.propTypes = {
	materials: PropTypes.arrayOf(CommonPropTypes.file).isRequired,
	toggler: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	slide: PropTypes.number
};

Lightbox.defaultProps = {
	slide: 0
};

export default Lightbox;
